import { Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { FilterSearchingAlertaMatriculaViewModel } from '../alertaMatriculaRechazada.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-alertamatricularechazada-filter',
    templateUrl: './alertamatricularechazada-filter.component.html',
})
export class AlertaMatriculaRechazadaFilterComponent extends ComponentBase implements OnInit {
    @Output() search = new EventEmitter<FilterSearchingAlertaMatriculaViewModel>();
    @Output() cleanForm = new EventEmitter<any>(); // Informa que el formulario se ha reseteado
    @Input() lastFilter: FilterSearchingAlertaMatriculaViewModel;

    public isCollapsed = false;

    constructor(
        private fb: FormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.createForm();
        this.recoverLastSearch();
    }

    private createForm(): void {
        this.form = this.fb.group({
            Codigo: '',
            FechaEnvio: null,
            Matricula: '',
        });
    }

    resetForm($event: any): void {
        $event.stopPropagation();
        this.form.setValue({
            Codigo: '',
            FechaEnvio: null,
            Matricula: '',
        });
        this.form.markAsPristine();

        this.searchingButton = false;
        this.isCollapsed = false;

        this.cleanForm.emit();
    }

    onSearch($event: any): void {
        $event?.stopPropagation();
        this.searchingButton = true;
        this.isCollapsed = true;

        const payload: FilterSearchingAlertaMatriculaViewModel = {
            ...this.form.value,
            PageNumber: this.lastFilter?.PageNumber || 0,
            Asc: this.lastFilter?.Asc || 0,
            OrderBy: this.lastFilter?.OrderBy || '',
        };

        this.search.emit(payload);
    }

    formIsUntouched(): boolean {
        return this.form.pristine || !this.form.dirty;
    }

    private recoverLastSearch(): void {
        if (this.lastFilter) {
            this.form.setValue({
                Codigo: this.lastFilter.Codigo,
                FechaEnvio: this.lastFilter.FechaEnvio,
                Matricula: this.lastFilter.Matricula,
            });
            this.form.markAsDirty();

            this.form.valueChanges.pipe(debounceTime(500)).subscribe(values => {
                if (values) {
                    this.clearPaginationFilter();
                }
            });

            setTimeout(() => {
                this.onSearch(null);
            }, 200);
        }
    }

    private clearPaginationFilter() {
        this.lastFilter.PageNumber = 0;
        this.lastFilter.Asc = 0;
        this.lastFilter.OrderBy = '';
    }

    get disableSearchBtn(): boolean {
        return this.isCollapsed;
    }
}
